<div class="sentiment-details-key-metrics">
  <div class="sentiment-details-key-metrics__card">
    <div class="sentiment-details-key-metrics__value">{{ actionableFeedback | number }}</div>
    <div class="sentiment-details-key-metrics__label">Actionable feedback</div>
  </div>
  <div class="sentiment-details-key-metrics__card">
    <div class="sentiment-details-key-metrics__value">{{ positiveActionable | number }}</div>
    <div class="sentiment-details-key-metrics__label">Positive actionable</div>
  </div>
  <div class="sentiment-details-key-metrics__card">
    <div class="sentiment-details-key-metrics__value">{{ neutralActionable | number }}</div>
    <div class="sentiment-details-key-metrics__label">Neutral actionable</div>
  </div>
  <div class="sentiment-details-key-metrics__card">
    <div class="sentiment-details-key-metrics__value">{{ negativeActionable | number }}</div>
    <div class="sentiment-details-key-metrics__label">Negative actionable</div>
  </div>
</div>
